import { cx } from "@/lib/cx";

import styles from "./Skeleton.module.css";

/** Placeholder block while content loads. Decorative: the region announces loading itself. */
export function Skeleton({ className }: { className?: string | undefined }) {
  return <span aria-hidden="true" className={cx(styles.skeleton, className)} />;
}
